import React from 'react';
import { OrdemDeServicoFormView } from '../components/ordemServico/OrdemDeServicoFormView';

interface VisualizarOSModalProps {
  osId: number | null;
  onClose: () => void;
}

export function VisualizarOSModal({ osId, onClose }: VisualizarOSModalProps) {
  if (!osId) return null;

  return (
    <OrdemDeServicoFormView
      osId={osId}
      onClose={onClose}
    />
  );
}
